module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(!_vm.hasGenerated) ? _c('div', [_c('div', {
    staticClass: "row"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 col-md-8 mt-20"
  }, [(_vm.visible) ? _c('div', {
    staticClass: "clearfix"
  }, [_c('div', {
    staticClass: "panel panel-default mai-panel"
  }, [_vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "panel-body clearfix",
    staticStyle: {
      "min-height": "380px"
    }
  }, [_c('am-map', {
    attrs: {
      "mapData": _vm.mapData
    }
  })], 1)])]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 col-md-4 mt-20"
  }, [_c('div', {
    staticClass: "clearfix"
  }, [_c('div', {
    staticClass: "panel panel-default mai-panel"
  }, [_vm._m(2), _vm._v(" "), _c('div', {
    staticClass: "panel-body clearfix",
    staticStyle: {
      "min-height": "380px"
    }
  }, [_c('info-widget', {
    staticClass: "col-xs-12 mt-20",
    attrs: {
      "stats": {
        title: '# Potential Lookups',
        stat: _vm.lookups.length
      },
      "backgroundColor": "#00beee",
      "logo": "fa fa-binoculars",
      "color": "#fff",
      "animate": ""
    }
  }), _vm._v(" "), _c('info-widget', {
    staticClass: "col-xs-12 mt-20",
    attrs: {
      "stats": {
        title: '# Locations Used',
        stat: _vm.locations.length
      },
      "backgroundColor": "#02a85c",
      "logo": "fa fa-globe",
      "color": "#fff",
      "animate": ""
    }
  }), _vm._v(" "), _c('info-widget', {
    staticClass: "col-xs-12 mt-20",
    attrs: {
      "stats": {
        title: '# Potential Lines ',
        stat: _vm.cLines.length * _vm.lookups.length
      },
      "backgroundColor": "#f39c11",
      "logo": "fa fa-industry",
      "color": "#fff",
      "animate": ""
    }
  })], 1)])])]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12"
  }, [_c('div', {
    staticClass: "clearfix"
  }, [_c('div', {
    staticClass: "panel panel-default mai-panel"
  }, [_vm._m(3), _vm._v(" "), _c('div', {
    staticClass: "panel-body clearfix",
    staticStyle: {
      "min-height": "380px"
    }
  }, [_c('vue-table', {
    attrs: {
      "showDelete": false,
      "showEdit": false,
      "tableData": _vm.overviewTableData,
      "tableTitle": "Details",
      "fields": [{
          prop: 'key',
          header: 'Item'
        },
        {
          prop: 'val',
          header: 'Entry'
        }
      ]
    }
  })], 1)])])])])]) : _vm._e(), _vm._v(" "), (_vm.hasGenerated) ? _c('div', [_vm._m(4), _vm._v(" "), _c('vue-table', {
    attrs: {
      "showDelete": false,
      "showEdit": false,
      "tableData": _vm.generatedLookups,
      "tableTitle": "Lookups",
      "fields": _vm.headers,
      "hasSlot": true
    },
    scopedSlots: _vm._u([{
      key: "icons",
      fn: function(maiScope) {
        return _c('div', {}, [_c('div', {
          class: [maiScope.item.id ? 'sq wide' : '', 'btn btn-danger'],
          attrs: {
            "data-toggle": "tooltip",
            "title": "Delete"
          },
          on: {
            "click": function($event) {
              return _vm.removeLookup({
                item: maiScope.item,
                index: maiScope.index
              })
            }
          }
        }, [_c('i', {
          staticClass: "fa fa-trash"
        })]), _vm._v(" "), (!maiScope.item.id) ? _c('div', {
          staticClass: "btn btn-success",
          attrs: {
            "data-toggle": "tooltip",
            "title": "Save"
          },
          on: {
            "click": function($event) {
              return _vm.saveLookup(maiScope.item, maiScope.index)
            }
          }
        }, [_c('i', {
          staticClass: "fa fa-check"
        })]) : _vm._e(), _vm._v(" "), (maiScope.item.id) ? _c('parse-from-json', {
          attrs: {
            "disabled": false,
            "json": _vm.generateLines(maiScope.item),
            "fileName": ("lookup-" + (maiScope.item.id) + "-lines")
          }
        }) : _vm._e(), _vm._v(" "), (maiScope.item.id) ? _c('parse-to-json', {
          attrs: {
            "showIcon": false
          },
          on: {
            "parse-start": _vm.parsing,
            "parse-complete": _vm.parsed
          }
        }) : _vm._e()], 1)
      }
    }], null, false, 453374319)
  })], 1) : _vm._e(), _vm._v(" "), _c('footer', {
    staticClass: "clearfix"
  }, [_c('hr'), _vm._v(" "), _vm._m(5), _vm._v(" "), _c('div', {
    staticClass: "pull-right"
  }, [_c('div', {
    class: [_vm.details.id ? '' : 'disabled', 'btn btn-primary sq'],
    on: {
      "click": _vm.generate
    }
  }, [_vm._v("\n        Regenerate\n      ")])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-xs-12"
  }, [_c('blockquote', [_vm._v("\n          Tariff Profile Overview\n        ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "panel-heading"
  }, [_c('i', {
    staticClass: "fa fa-bar-chart"
  }), _vm._v(" Countries used by this profile")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "panel-heading"
  }, [_c('i', {
    staticClass: "fa fa-info"
  }), _vm._v(" Profile info")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "panel-heading"
  }, [_c('i', {
    staticClass: "fa fa-info"
  }), _vm._v(" Details")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-12"
  }, [_c('blockquote', [_vm._v("\n          Lookups\n        ")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h5', [_vm._v("\n      If the above information looks correct, you can (re)generate and then subquently save new tariffs by clicking the regenerate button to the right;\n      "), _c('strong', [_vm._v("ALL PRIOR EXISTING TARIFFS FROM THIS PROFILE WILL BE DELETED")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-0ff8281e"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/modules/rateassist/components/Lookups.vue
// module id = 2091
// module chunks = 1